import React, { useState, useRef } from 'react';
import Console from './Console';
import { ConsoleRef, ConsoleOutput } from './types';

const ConsoleTest: React.FC = () => {
  const [output, setOutput] = useState<ConsoleOutput[]>([]);
  const consoleRef = useRef<ConsoleRef>(null);

  const addTestMessage = (type: ConsoleOutput['type'], message: string, data?: any) => {
    const newOutput: ConsoleOutput = {
      id: Date.now().toString(),
      type,
      message,
      timestamp: new Date(),
      data,
    };
    setOutput(prev => [...prev, newOutput]);
  };

  const handleClear = () => {
    setOutput([]);
  };

  const runTest = () => {
    // Clear existing output
    setOutput([]);
    
    // Add test messages
    setTimeout(() => addTestMessage('info', 'Starting console test...'), 100);
    setTimeout(() => addTestMessage('log', 'This is a regular log message'), 300);
    setTimeout(() => addTestMessage('success', 'Operation completed successfully!'), 500);
    setTimeout(() => addTestMessage('warn', 'This is a warning message'), 700);
    setTimeout(() => addTestMessage('error', 'An error occurred during execution'), 900);
    setTimeout(() => addTestMessage('log', 'Test completed with sample data', { 
      testResults: { passed: 3, failed: 1, total: 4 },
      executionTime: '1.2s'
    }), 1100);
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Console Component Test</h2>
      <p>This component tests the Console component functionality with different message types.</p>
      
      <div style={{ marginBottom: '20px' }}>
        <button onClick={runTest} style={{ marginRight: '10px' }}>
          🚀 Run Test
        </button>
        <button onClick={handleClear}>
          🗑️ Clear Console
        </button>
      </div>

      <Console
        ref={consoleRef}
        output={output}
        height={400}
        theme="dark"
        onClear={handleClear}
      />
    </div>
  );
};

export default ConsoleTest;
